<script>
import TestimonialCard from './TestimonialCard.vue';
import { getTestimonialContent } from '../../../../../api/testimonials';
export default {
  components: { TestimonialCard },
  emits: ['resizeContainers'],
  data() {
    return {
      testimonials: [],
      socialBadges: [
        {
          id: 'twitter',
          icon: 'i-lucide-twitter',
          wrapperClass:
            'top-16 left-24 h-16 w-16 bg-white/90 text-[#1DA1F2] ring-2 ring-white/80 shadow-[0_20px_60px_-20px_rgba(29,161,242,0.65)]',
          iconClass: 'text-[#1DA1F2]',
        },
        {
          id: 'instagram',
          icon: 'i-lucide-instagram',
          wrapperClass:
            'top-24 right-24 h-14 w-14 bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white ring-2 ring-white/70 shadow-[0_20px_60px_-20px_rgba(221,42,123,0.6)]',
          iconClass: 'text-white',
        },
        {
          id: 'linkedin',
          icon: 'i-lucide-linkedin',
          wrapperClass:
            'bottom-48 left-32 h-14 w-14 bg-white/90 text-[#0A66C2] ring-2 ring-white/80 shadow-[0_20px_60px_-20px_rgba(10,102,194,0.6)]',
          iconClass: 'text-[#0A66C2]',
        },
        {
          id: 'telegram',
          icon: 'i-woot-telegram',
          wrapperClass:
            'bottom-28 right-32 h-16 w-16 bg-[#229ED9] text-white ring-4 ring-[#229ED9]/40 shadow-[0_24px_64px_-24px_rgba(34,158,217,0.7)]',
          iconClass: 'text-white',
        },
      ],
    };
  },
  beforeMount() {
    this.fetchTestimonials();
  },
  methods: {
    async fetchTestimonials() {
      try {
        const { data } = await getTestimonialContent();
        // Shuffle testimonials and limit to 2
        const shuffled = [...data].sort(() => Math.random() - 0.5);
        this.testimonials = shuffled.slice(0, 2);
      } catch (error) {
        // Ignoring the error as the UI wouldn't break
      } finally {
        this.$emit('resizeContainers', !!this.testimonials.length);
      }
    },
  },
};
</script>

<template>
  <div
    v-show="testimonials.length"
    class="relative hidden min-h-screen flex-1 overflow-hidden bg-gradient-to-br from-n-amber-9 via-n-amber-8 to-n-amber-7 dark:from-n-blue-5 dark:via-n-blue-6 dark:to-n-indigo-6 xl:flex"
  >
    <div class="absolute inset-0 opacity-60">
      <img
        src="assets/images/auth/top-left.svg"
        class="absolute top-0 left-0 h-40 w-40"
      />
      <img
        src="assets/images/auth/bottom-right.svg"
        class="absolute bottom-0 right-0 h-40 w-40"
      />
      <img
        src="assets/images/auth/auth--bg.svg"
        class="absolute left-[6%] top-[8%] h-[96%] w-[96%]"
      />
    </div>

    <div
      v-for="badge in socialBadges"
      :key="badge.id"
      class="pointer-events-none absolute hidden items-center justify-center rounded-full backdrop-blur-xl xl:flex"
      :class="badge.wrapperClass"
    >
      <span class="text-2xl" :class="[badge.icon, badge.iconClass]" />
    </div>

    <div
      class="pointer-events-none absolute -left-24 top-20 h-72 w-72 rounded-full bg-n-amber-5/40 blur-3xl"
    />
    <div
      class="pointer-events-none absolute -bottom-24 right-10 h-80 w-80 rounded-full bg-n-amber-7/40 blur-3xl"
    />

    <div
      class="relative z-50 flex h-full min-h-screen w-full items-center justify-center px-10"
    >
      <div class="relative h-[32rem] w-full max-w-[32rem]">
        <div
          class="pointer-events-none absolute left-1/2 top-8 h-20 w-20 -translate-x-1/2 rounded-3xl border border-white/30 bg-white/10 backdrop-blur-xl"
        />
        <div
          class="pointer-events-none absolute bottom-6 right-10 h-24 w-24 rounded-full border border-white/10 bg-white/15 backdrop-blur-lg"
        />
        <div
          class="pointer-events-none absolute inset-0 rounded-[3rem] border border-white/10"
        />

        <TestimonialCard
          v-for="(testimonial, index) in testimonials"
          :key="testimonial.id"
          :review-content="testimonial.authorReview"
          :author-image="testimonial.authorImage"
          :author-name="testimonial.authorName"
          :author-designation="testimonial.authorCompany"
          class="animate-fade-in-up transform-gpu transition-all duration-700 ease-out"
          :class="[
            index === 0
              ? 'absolute left-0 top-6 rotate-[-5deg] drop-shadow-[0_35px_60px_-30px_rgba(255,106,0,0.6)]'
              : 'absolute right-0 bottom-6 rotate-3 drop-shadow-[0_35px_60px_-30px_rgba(32,32,64,0.45)]',
            index === 0 ? 'z-20' : 'z-10',
          ]"
        />
      </div>
    </div>
  </div>
</template>
